import api from '../../../api';

/**
 * Investors API client — Investor CRM / portfolio explorer.
 * Consumes the buyer-portal investors endpoints.
 */

const INVESTORS_BASE = '/api/buyer-portal/investors';

/**
 * Fetch the investors explorer list: totals rollup + one row per investor.
 * @param {Object} [opts]
 * @param {string} [opts.search] - name/email/phone search term
 * @param {('portfolio_value'|'total_equity'|'accessible_equity'|'annual_cashflow'|'property_count')} [opts.sort]
 * @returns {Promise<{count, totals, investors}>}
 */
export const fetchInvestors = async ({ search, sort, filters } = {}) => {
    try {
        const params = {};
        if (search && search.trim()) params.search = search.trim();
        if (sort) params.sort = sort;
        // Drill-down / Level-2 filters (entity, cashflow, state, suburb, fixed_expiring, …)
        if (filters && typeof filters === 'object') {
            Object.entries(filters).forEach(([k, v]) => {
                if (v === true) params[k] = 1;
                else if (v !== undefined && v !== null && v !== '' && v !== false) params[k] = v;
            });
        }
        const response = await api.get(`${INVESTORS_BASE}/`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching investors:', error);
        throw error;
    }
};

/**
 * Fetch one investor's full portfolio drill-down: header, totals, portfolios
 * (with their properties) and the recent activity feed.
 * @param {number|string} id - investor id
 * @returns {Promise<{investor, totals, portfolios, activity}>}
 */
export const fetchInvestorDetail = async (id) => {
    try {
        const response = await api.get(`${INVESTORS_BASE}/${id}/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching investor detail:', error);
        throw error;
    }
};

/**
 * Fetch the recent activity feed for one investor.
 * @param {number|string} id - investor id
 * @param {number} [limit] - max events to return
 * @returns {Promise<Array>}
 */
export const fetchInvestorActivity = async (id, limit) => {
    try {
        const params = {};
        if (limit) params.limit = limit;
        const response = await api.get(`${INVESTORS_BASE}/${id}/activity/`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching investor activity:', error);
        throw error;
    }
};
